// extracted by mini-css-extract-plugin
export var container = "about-module--container--3Egkk";
export var intro = "about-module--intro--1useZ";
export var boke0 = "about-module--boke0--2GLnj";
export var works = "about-module--works--2N51N";
export var worksList = "about-module--worksList--24d3D";
export var item = "about-module--item--R-kPY";
export var title = "about-module--title--3uWzG";
export var description = "about-module--description--3a1Eh";
export var link = "about-module--link--2gNrx";